import React from "react";
import { compose } from "recompose";
import {
  Form,
  Col,
  Row,
  message,
  Button,
  Input,
  Select,
  Checkbox,
  Typography,
  Upload,
  Icon,
  Modal,
} from "antd";
import { withApollo, graphql } from "react-apollo";
import styled from "styled-components";
import UAParser from "ua-parser-js";
import publicIp from "public-ip";
import SignaturePad from "react-signature-pad-wrapper";
import { renderOptions, renderOptionsWithImg } from "./static";
// import { PerfilContainer } from "./style";
// import * as route from "../../../routes/routes";
import { createPreaffiliateUser } from "../../graphQl/mutations/account";
import { captureException } from "../../utils/sentry";
import { getAllCountries } from "../../graphQl/queries/countries";
import {
  InputComponent,
  SelectComponent,
  InputEmailComponent,
} from "../../components/FormFields";
import { ModalContainer, SignatureContainer } from "../Register/styles";
import {
  beforeUpload,
  uploadBase64Image,
  getBase64Promise,
} from "../../utils/functions";
import { withFirebase } from "../../firebase";
// import './styles.css';
// const urlBackground =
//  "https://chazkistorage.blob.core.windows.net/resources/portada-chazki.jpg";
const { Text, Paragraph } = Typography;
const BodyCreateUser = styled.div`
  position: relative;
  display: flex;
  height: 100vh;
  flex-direction: row;

  .RightSide {
    width: 60%;
    .GreenContainerCircle {
      position: absolute;
      top: -223px;
      left: -190px;
      width: 1030px;
      height: 1030px;
      background-color: #44d62c;
      border-radius: 650px;
      overflow: hidden;
    }

    img {
      height: 612px;
      position: absolute;
      bottom: 0px;
      left: 0px;
    }

    @media only screen and (max-width: 50em) {
      display: none;
    }
  }
  .LeftSide {
    display: flex;
    width: 40%;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    h1 {
      font-family: Gilroy;
      font-style: normal;
      font-weight: bold;
      font-size: 32px;
      line-height: 36px;
      color: #595959;
      margin-bottom: 24px;
    }

    .formStyle {
      width: 100%;

      font-family: Gilroy;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 18px;
    }

    .ant-btn {
      width: 100%;
      height: 48px;
    }

    .login {
      font-family: Gilroy;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 18px;

      a {
        font-weight: 600;
        font-size: 14px;
        line-height: 16px;
        color: 307fe2;
      }
      margin-top: 17px;
    }

    .message-after-create {
      position: relative;
      z-index: 9999;
      max-width: 720px;
      margin: -12rem 4rem 2rem auto;
      padding: 2.4rem;
      background-color: #ffffff;
      border-radius: 20px;
      box-shadow: 0 20px 35px -8px rgba(0, 0, 0, 0.1),
        0 5px 12px -4px rgba(0, 0, 0, 0.05);
      font-family: "Inter", system-ui, -apple-system, sans-serif;
      border: 1px solid #e9eef2;
    }

    .message-after-create .icon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 56px;
      height: 56px;
      background: linear-gradient(135deg, #e6f0ff, #d4e2fc);
      border-radius: 18px;
      margin-bottom: 1.2rem;
    }

    .message-after-create .icon svg {
      width: 28px;
      height: 28px;
      color: #1e4f8a;
      stroke: #1e4f8a;
      fill: none;
    }

    .message-after-create h3 {
      font-size: 2.2rem;
      font-weight: 700;
      color: #0b2a41;
      margin: 0 0 0.5rem 0;
      letter-spacing: -0.01em;
    }

    .message-after-create p {
      font-size: 1.5rem;
      color: #2c3e50;
      margin: 0 0 1.2rem 0;
      line-height: 1.6;
    }

    .message-after-create strong {
      color: #0b2a41;
      font-weight: 600;
      font-size: 1.7rem;
    }

    .message-after-create .deadline {
      display: inline-block;
      background-color: #fff7e5;
      color: #ad6200;
      font-weight: 600;
      padding: 0.2rem 1rem;
      border-radius: 30px;
      font-size: 1.4rem;
      margin: 0 0.2rem;
      border: 1px solid #ffe0a8;
      white-space: nowrap;
    }

    .message-after-create .button-container {
      margin-top: 3rem;
      text-align: center;
    }

    .message-after-create .home-button {
      display: inline-block;
      background: linear-gradient(135deg, #1a5f9e, #134580);
      color: white;
      font-weight: 600;
      font-size: 1.4rem;
      padding: 0.8rem 2rem;
      border-radius: 50px;
      text-decoration: none;
      border: none;
      box-shadow: 0 4px 12px rgba(20, 70, 120, 0.2);
      border: 1px solid rgba(255, 255, 255, 0.1);
    }

    .btn-create-account {
      background-color: #307fe2;
      color: white;
      font-family: Gilroy;
      font-style: normal;
      font-weight: bold;
      font-size: 14px;
      line-height: 16px;
    }

    @media only screen and (max-width: 50em) {
      width: 100%;
      padding-left: 20px;
      padding-right: 20px;

      align-items: flex-start;
      justify-content: flex-start;
      padding-top: 30px;
      padding-bottom: 20px;

      .login {
        text-align: center;
      }
    }
  }
`;

class CreateAccount extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sentDateToCreate: false,
      loadingBtnSumit: false,
      ip: null,
      viewModal: false,
      checked: false,
      loadingUpload: false,
      fileList: [],
    };
    this.signaturePad = React.createRef();
  }

  componentDidMount = async () => {
    this.getIpPublic();
  };

  getIpPublic = async () => {
    const myIp = await publicIp.v4();
    this.setState({ ip: myIp });
  };

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        // console.log("values", values);
        if (!values.acceptTC) {
          message.error("Acepte los terminos y condiciones para continuar.");
          return;
        }
        const formatValues = values;
        formatValues.cityID = Number(values.cityID);
        formatValues.urlRedirect = `${process.env.REACT_APP_URL}check-code`;
        formatValues.urlLogin = `${process.env.REACT_APP_URL}login`;
        formatValues.versionTC = this.props.getAllCountries.GetAllCountries.find(
          obj => obj.id === values.countryID
        ).versionTC;

        formatValues.deviceIP = this.state.ip;
        const params = new URLSearchParams(this.props.location?.search ?? "");
        const uuid = params.get("uuid");
        if (uuid) {
          formatValues.clientMetadataID = uuid;
        }

        const deviceData = new UAParser();
        formatValues.deviceInfo = {
          mac: null,
          model: deviceData.getDevice().model,
          brand: deviceData.getEngine().name,
          versionSO: JSON.stringify(deviceData.getOS()),
        };

        delete formatValues.agreement;
        // console.log("formatValues", formatValues);
        this.uploadImages(formatValues);
      }
    });
  };

  FunCreateAccount = variables => {
    this.props.client
      .mutate({
        mutation: createPreaffiliateUser,
        update: (cache, { data: { CreatePreaffiliateUser } }) => {
          console.log("CreatePreaffiliateUser", CreatePreaffiliateUser);
          this.setState({ loadingBtnSumit: false, sentDateToCreate: true });
          // setTimeout(() => {
          //   navigate(`/`);
          // }, 15000);
        },
        variables,
      })
      .catch(error => {
        captureException(error);
        if (error.graphQLErrors) {
          message.error(error.graphQLErrors.map(err => err.message).join(", "));
        } else {
          message.error("No se pudo guardar, error en el sistema");
        }
        this.setState({ loadingBtnSumit: false });
      });
  };

  uploadImages = async values => {
    const { firebase } = this.props;
    try {
      this.setState({ loadingBtnSumit: true });

      const { signatureImage } = this.state;
      // Validar que el usuario realmente haya firmado
      if (
        !signatureImage ||
        signatureImage === "data:,"
      ) {
        throw new Error("La firma está vacía.");
      }
      const selfieImage = await getBase64Promise(
        this.state.fileList[0].originFileObj
      );
      // Carpeta destino
      const folderPathSignature = "gameboy_files/tyc_evidence/signatures";
      const folderPathSelfie = "gameboy_files/tyc_evidence/selfies";
      // Subir ambas imágenes en paralelo
      const [urlFileSignature, urlFileSelfie] = await Promise.all([
        uploadBase64Image(
          firebase,
          signatureImage,
          folderPathSignature,
          `${values.names}_${values.lastname}`
        ),
        uploadBase64Image(
          firebase,
          selfieImage,
          folderPathSelfie,
          `${values.names}_${values.lastname}`
        ),
      ]);

      this.FunCreateAccount({ ...values, urlFileSignature, urlFileSelfie });
    } catch (error) {
      this.signaturePad.current.clear();
      console.error("Error al subir las imágenes:", error);
      message.error(
        "Error al cargar las imágenes, vuelva a firmar y subir la selfie."
      );
      this.setState({
        loadingBtnSumit: false,
      });
    }
  };

  onChangeCountries = countryID => {
    const { resetFields } = this.props.form;
    const {
      getAllCountries: { GetAllCountries },
    } = this.props;
    resetFields(["cityID"]);
    const positionCity =
      GetAllCountries && GetAllCountries.findIndex(x => x.id === countryID);
    if (positionCity > -1)
      this.setState({
        cities: GetAllCountries[positionCity].Cities,
        termsandconditions: GetAllCountries[positionCity].termsandconditions,
      });
  };

  handleTyC = e => {
    if (e.target.checked) {
      this.setState({ viewModal: true });
    } else {
      this.setState({ fileList: [], signatureImage: null });
      this.signaturePad.current.clear();
    }
  };

  handleChangeUpload = ({ file, fileList }) =>
    this.setState({
      fileList: file.type && file.type.startsWith("image/") ? fileList : []
    });

  myBeforeUpload = file => {
    beforeUpload(file);
    return false;
  };

  handlePreview = async file => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64Promise(file.originFileObj);
    }
    this.setState({
      previewImage: file.url || file.preview,
      previewVisible: true,
    });
  };

  handleCancel = () => this.setState({ previewVisible: false });

  onCancelModal = () => {
    this.props.form.resetFields(["acceptTC"]);
    this.signaturePad.current.clear();
    this.setState({
      fileList: [],
      viewModal: false,
      signatureImage: null,
    });
  };

  onOkModal = () => {
    if (
      this.signaturePad.current.isEmpty() ||
      this.state.fileList.length === 0
    ) {
      message.error(
        this.signaturePad.current.isEmpty()
          ? "¡No proporcionaste tu firma!"
          : "¡No subiste tu selfie!"
      );
      return;
    }
    const signatureImage = this.signaturePad.current.toDataURL("image/png");
    this.setState({
      signatureImage,
      viewModal: false,
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const {
      sentDateToCreate,
      loadingBtnSumit,
      cities,
      termsandconditions,
      fileList,
      previewVisible,
      previewImage,
    } = this.state;
    const {
      getAllCountries: { GetAllCountries, loading: loadingCountries },
    } = this.props;

    const prefixSelector = getFieldDecorator("countryID", {
      initialValue: "1",
    })(
      <Select
        optionLabelProp="label"
        style={{ width: 70 }}
        showSearch
        loading={loadingCountries}
        onChange={this.onChangeCountries}
        optionFilterProp="children"
        filterOption={(input, option) =>
          option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
        placeholder="País"
        dropdownMatchSelectWidth={false}
      >
        {renderOptionsWithImg(GetAllCountries)}
      </Select>
    );

    const uploadButton = (
      <div>
        <Icon type="plus" />
        <div className="ant-upload-text">Upload</div>
      </div>
    );

    return (
      <BodyCreateUser>
        <div className="RightSide">
          <div className="GreenContainerCircle">
            <img
              alt=""
              src="https://firebasestorage.googleapis.com/v0/b/chazki-link.appspot.com/o/nintendo%2FIconsGameboy%2Fimage%203.png?alt=media&token=79fe89ed-4992-4caa-9150-4edd5e7a1e16"
            />
          </div>
        </div>
        <div className="LeftSide">
          {!sentDateToCreate ? (
            <Form hideRequiredMark id="saveAccount" className="formStyle">
              <Row>
                <Col xs={24} sm={24} md={4} lg={4} xl={4}></Col>
                <Col xs={24} sm={24} md={16} lg={16} xl={16}>
                  <img
                    style={{ marginBottom: 78 }}
                    height={32}
                    alt="Chazi Logo"
                    src="https://firebasestorage.googleapis.com/v0/b/chazki-link.appspot.com/o/nintendo%2FlogoAzul.png?alt=media&token=3e30a697-89bf-413c-b7c3-5c3e55478833"
                  />
                  <h1>
                    ¿Todo listo para una nueva aventura? Regístrate y crea tu
                    cuenta.
                  </h1>
                  <div>
                    <InputComponent
                      getFieldDecorator={getFieldDecorator}
                      decodator="names"
                      placeholder="Nombres"
                      message="Debe ingresar un nombre"
                      required
                    />

                    <InputComponent
                      getFieldDecorator={getFieldDecorator}
                      decodator="lastname"
                      placeholder="Apellidos"
                      message="Debe ingresar sus apellidos"
                      hasFeedback
                      required
                    />
                    <InputEmailComponent
                      getFieldDecorator={getFieldDecorator}
                      decodator="email"
                      placeholder="Correo electrónico"
                      message="El correo es incorrecto"
                      required
                    />
                    <Form.Item>
                      {getFieldDecorator("password", {
                        rules: [
                          {
                            required: true,
                            message: "Debe ingresar una contraseña",
                          },
                        ],
                      })(
                        <Input.Password
                          size="large"
                          style={{ width: "100%" }}
                          placeholder="Contraseña"
                        />
                      )}
                    </Form.Item>

                    <Form.Item>
                      {getFieldDecorator("phone", {
                        rules: [
                          {
                            required: true,
                            message: "El teléfono es incorrecto",
                          },
                        ],
                      })(
                        <Input
                          size="large"
                          placeholder="Teléfono"
                          addonBefore={prefixSelector}
                          style={{ width: "100%" }}
                        />
                      )}
                    </Form.Item>

                    <SelectComponent
                      getFieldDecorator={getFieldDecorator}
                      decodator="cityID"
                      options={renderOptions(
                        cities ||
                        (GetAllCountries &&
                          GetAllCountries.find(obj => obj.id === "1").Cities)
                      )}
                      message="Debe seleccionar una ciudad"
                      placeholder="Ciudad"
                      required
                    />
                  </div>

                  <Form.Item>
                    {getFieldDecorator("acceptTC", {
                      rules: [
                        {
                          required: true,
                          message: "Este campo es obligatorio.",
                        },
                      ],
                      valuePropName: "checked",
                      initialValue: this.state.checked,
                    })(
                      <Checkbox required onChange={this.handleTyC}>
                        <a
                          href={
                            termsandconditions ||
                            (GetAllCountries &&
                              GetAllCountries.find(obj => obj.id === "1")
                                .termsandconditions)
                          }
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Acepto los términos y condiciones.
                        </a>
                      </Checkbox>
                    )}
                  </Form.Item>

                  <Button
                    type="submit"
                    loading={loadingBtnSumit}
                    className="btn-create-account"
                    onClick={this.handleSubmit}
                  >
                    Regístrate
                  </Button>
                  <div className="login">
                    ¿Eres Chazki o ya has completado el registro?
                    <a href="/"> Iniciar sesión</a>
                  </div>
                </Col>
              </Row>
              <Col xs={24} sm={24} md={4} lg={4} xl={4}></Col>
            </Form>
          ) : (
            <div className="message-after-create">
              <div className="icon">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                  <polyline points="22,6 12,13 2,6" />
                </svg>
              </div>
              <h3>Tu cuenta ha sido creada</h3>
              <p>
                <strong>Accede a tu correo electrónico</strong> para confirmar
                la creación de tu cuenta. Tienes{" "}
                <span className="deadline">72 horas</span> para completar este
                paso.
              </p>
              <p>
                ¿No recibiste el correo? Revisa tu{" "}
                <strong>carpeta de spam</strong>.
              </p>

              <div className="button-container">
                <a href="/" className="home-button">
                  Ir a la página de inicio
                </a>
              </div>
            </div>
          )}
        </div>
        <ModalContainer
          visible={this.state.viewModal}
          onOk={this.onOkModal}
          onCancel={this.onCancelModal}
          maskClosable={false}
          closable={false}
          style={{ top: 30 }}
        >
          <Paragraph>
            Al firmar y subir una selfie en la que sostienes tu documento de
            identidad, confirmas que has leído y aceptas los términos y
            condiciones aplicables a este servicio. Esta información es
            necesaria para verificar tu identidad y formalizar tu aceptación.
          </Paragraph>
          <Text strong>Por favor, proporciona tu firma</Text>
          <SignatureContainer>
            <SignaturePad
              redrawOnResize
              ref={this.signaturePad}
              height={140}
            // options={{backgroundColor: 'rgb(236, 236, 236)'}}
            />

            <Button
              className="bottom-clear"
              type="link"
              onClick={() => this.signaturePad.current.clear()}
            >
              limpiar
            </Button>
          </SignatureContainer>
          <Text strong>Sube una selfie con tu identificación a la mano</Text>
          <Upload
            className="custom-upload"
            fileList={fileList}
            listType="picture-card"
            onChange={this.handleChangeUpload}
            beforeUpload={this.myBeforeUpload}
            onPreview={this.handlePreview}
          >
            {fileList.length >= 1 ? null : uploadButton}
          </Upload>
        </ModalContainer>
        <Modal
          visible={previewVisible}
          footer={null}
          onCancel={this.handleCancel}
        >
          <img alt="img" style={{ width: "100%" }} src={previewImage} />
        </Modal>
      </BodyCreateUser>
    );
  }
}
const UploadCreateAccount = withFirebase(CreateAccount);
const FormCreateAccount = Form.create()(UploadCreateAccount);

export default compose(
  graphql(getAllCountries, {
    name: "getAllCountries",
    options: () => {
      return {
        fetchPolicy: "network-only",
        notifyOnNetworkStatusChange: true,
        variables: {},
      };
    },
  }),
  withApollo
)(FormCreateAccount);
